import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=cbaac81a&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbaac81a')) {
      api.createRecord('cbaac81a', component.options)
    } else {
      api.reload('cbaac81a', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=cbaac81a&", function () {
      api.rerender('cbaac81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oICB6BKEZJ4t/JS/comp/pricelist.vue"
export default component.exports